import { type GlobalSearchResultTypeEnum } from '../enums'
import { type GlobalSearchResultItem } from '../GlobalSearchResultItem'

export interface GlobalSearchResultConstructor {
  items: GlobalSearchResultItem[]
  counts: Map<GlobalSearchResultTypeEnum, number>
  total: number
  isTruncated: boolean
  isUnsupportedQuery: boolean
}

export class GlobalSearchResult {
  readonly items: GlobalSearchResultItem[]
  readonly counts: Map<GlobalSearchResultTypeEnum, number>
  readonly total: number
  readonly isTruncated: boolean
  readonly isUnsupportedQuery: boolean

  constructor(data: GlobalSearchResultConstructor) {
    this.items = data.items
    this.counts = data.counts
    this.total = data.total
    this.isTruncated = data.isTruncated
    this.isUnsupportedQuery = data.isUnsupportedQuery
  }
}
